// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lZOY","select":"styles_select__3sfsD"};